export default __webpack_public_path__ + "static/media/radiusSquare.5e3fb65d.svg";